export default __webpack_public_path__ + "static/media/colorGame.a514195f.png";